export default {
  date: "Date",
  id: "ID",
  interacs: "Interac",
  settings: "Settings",
  transactions: "Transactions",
  messageFrom: "From",
  messageSubject: "Subject",
  invoice: "Invoice",
  amount: "Amount",
  paymentDate: "Payment Date",
  invoiceIsPaidWarning:
    "This invoice is already paid. Are you sure you want to create this transaction?",
  transactionCreated: "Transaction created successfully.",
  grossAmount: "Gross Amount",
  netAmount: "Net Amount",
  processingFee: "Processing Fee",
  platformFee: "Platform Fee",
  sendReceipt: "Send Receipt",
};
